export const sportsNames = [
    '(M) Baseball',
    '(M) Basketball',
    '(W) Basketball',
    '(W) Beach Volleyball',
    '(M) Cross Country',
    '(M) Golf',
    '(W) Rowing',
    '(M) Rugby',
    '(M) Soccer',
    '(W) Soccer',
    '(W) Softball',
    '(M) Tennis',
    '(W) Tennis',
    '(M) Track and Field',
    '(W) Track and Field',
    '(W) Volleyball',
  ]